// extracted by mini-css-extract-plugin
export default {"container":"ImageList_container__P0TgL","boxGroup":"ImageList_boxGroup__COPLH","box":"ImageList_box__6myI0"};